<mat-card class="mat-elevation-z8 realtime-container">
  <mat-card-title-group>
    <mat-card-subtitle>{{'booked_sector' | translate}}:</mat-card-subtitle>
    <mat-card-title *ngIf="(realTimeEnableSector === 0 || realTimeEnableSector === 49)">
      {{'no_sector_booked'| translate}}
    </mat-card-title>
    <mat-card-title *ngIf="(realTimeEnableSector !== 0 && realTimeEnableSector !== 49)">
      {{realTimeEnableSector}}
    </mat-card-title>
    <button mat-raised-button color="warn" (click)="stopRealTime()">Stop Real-Time</button>
  </mat-card-title-group>
  <br>
  <mat-card-content>
    <div class="card-content" *ngFor="let sector of listSectors">
      <mat-divider></mat-divider>
      <button mat-raised-button color="primary" (click)="startRealTime(sector)"
        style="width: 100%; margin-top: 2%; margin-bottom: 2%;">{{'book_realtime'| translate}}</button>
      <div class="mat-card-container">
        <mat-label>
          {{'status'| translate}}: <mat-icon *ngIf="(realtimeObj.sx_dx === sector)"
            style="color: green;">wifi</mat-icon><mat-icon *ngIf="(realtimeObj.sx_dx !== sector)"
            style="color: red;">wifi</mat-icon> </mat-label>
        <div class="states">
          {{'status'| translate}}
          <span *ngIf="(realtimeObj.sx_dx === sector)" [ngSwitch]="realtimeObj.stato">
            <div *ngSwitchCase="[1, 2, 4].includes(realtimeObj.stato) ? realtimeObj.stato : -1">
              <mat-icon>play_arrow</mat-icon>
            </div>
            <div *ngSwitchCase="[16, 32].includes(realtimeObj.stato) ? realtimeObj.stato : -1">
              <mat-icon class="rotate-8-s">refresh</mat-icon>
            </div>
            <div *ngSwitchCase="[8].includes(realtimeObj.stato) ? realtimeObj.stato : -1">
              <span>CN</span>
            </div>
            <div *ngSwitchCase="[0].includes(realtimeObj.stato) ? realtimeObj.stato : -1">
              <mat-icon>stop</mat-icon>
            </div>
            <div *ngSwitchDefault>
              <mat-icon>stop</mat-icon>
            </div>
          </span>
        </div>
        <div class="states">
          <div><mat-icon>notifications</mat-icon>{{'alarms_on_now' | translate}}</div>
          <div></div>
        </div>
        <div class="states">
          <div><mat-icon>thermostat</mat-icon>{{'tank_temperature' | translate}}</div>
          <span  *ngIf="(realtimeObj.sx_dx === sector)">{{(realtimeObj.temp_vasca !== 150) ? realtimeObj.temp_vasca + ' °C' : '---'}}</span>
        </div>
        <div class="states">
          <div><mat-icon>thermostat</mat-icon>{{'fluid_temperature' | translate}}</div>
          <span  *ngIf="(realtimeObj.sx_dx === sector)">{{(realtimeObj.temp_cts !== 150) ? realtimeObj.temp_cts + ' °C' : '---'}}</span>
        </div>
      </div>
        <div class="mat-card-container">
          {{'send_command' | translate | uppercase}}
          <button mat-raised-button color="primary" (click)="sendCommandRealTime(sector, 4)">{{'start_conservation' |
            translate | uppercase}}</button>
          <button mat-raised-button color="warn" (click)="sendCommandRealTime(sector, 100)">{{'stop_sector' | translate | uppercase}}</button>
        </div>
      </div>
  </mat-card-content>
</mat-card>
